module.exports = __webpack_public_path__ + "static/media/Book.7349b5a0.svg";